import React from 'react';
import {
  GlobeAltIcon,
  TruckIcon,
  BuildingOffice2Icon,
  ClockIcon,
  ExclamationTriangleIcon,
  ShieldCheckIcon,
  CubeIcon,
  BoltIcon,
  DocumentCheckIcon,
  ArrowPathIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';
import { SolutionPageTemplate } from '../../components/page-templates/MarketPageTemplates';

const painPoints = [
  {
    icon: GlobeAltIcon,
    title: 'Regional Fulfilment Complexity',
    description: 'You ship across multiple countries with different customs and tax rules',
  },
  {
    icon: ClockIcon,
    title: 'Channel-Driven Timelines',
    description: 'OEM and reseller commitments depend on predictable delivery',
  },
  {
    icon: ExclamationTriangleIcon,
    title: 'Limited Operational Flexibility',
    description: 'In-house logistics teams are not built for global scale',
  },
  {
    icon: ArrowPathIcon,
    title: 'Returns and Swaps',
    description: 'RMA handling adds cost, delays, and operational burden',
  },
];

const solutions = [
  {
    icon: BuildingOffice2Icon,
    title: 'Warehousing & Fulfilment Hubs',
    points: [
      'Regional warehousing in Singapore, UAE, and US',
      'Centralised inventory management',
      'Streamlined outbound logistics',
      'Flexible support for channel timelines',
    ],
  },
  {
    icon: DocumentCheckIcon,
    title: 'Freight & Compliance',
    points: [
      'Consolidated shipments across borders',
      'IOR/EOR services for regulated markets',
      'Full customs management',
      'Cross-border coordination',
    ],
  },
  {
    icon: ArrowPathIcon,
    title: 'RMA & Reverse Logistics',
    points: [
      'Structured RMA handling and processing',
      'Inspection and validation workflows',
      'Faster turnaround times',
      'Reduced channel disruption',
    ],
  },
];

const whyChooseCards = [
  {
    icon: BoltIcon,
    title: 'Accelerated Regional Expansion',
    description: 'Inventory positioned in major trade corridors for faster sales growth and market entry.',
    accent: 'bg-blue-500',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Margin Protection & Capital Efficiency',
    description: 'Structured flows reduce working capital requirements and protect profitability across channels.',
    accent: 'bg-cyan-500',
  },
  {
    icon: ChartBarIcon,
    title: 'Full Market Visibility & Channel Control',
    description: 'Centralised reporting improves service levels to OEMs and resellers worldwide.',
    accent: 'bg-indigo-500',
  },
];

const OemsHardware: React.FC = () => (
  <SolutionPageTemplate
    eyebrow="OEMs & Hardware Vendors"
    title="Accelerate International Market Access"
    highlight="Market Access"
    description="TrueLog acts as your execution engine, handling regional and cross-border fulfilment so you can focus on sales and expanding market reach."
    heroIcon={CubeIcon}
    heroAccentIcon={TruckIcon}
    problemHeading="Scale distribution without execution friction"
    problemDescription="Growing internationally means navigating compliance, channel commitments, and reverse logistics at scale."
    painPoints={painPoints}
    solutionsIntro="TrueLog handles the infrastructure behind your sales channel so your team can move faster in market."
    solutions={solutions}
    whyChooseCards={whyChooseCards}
    ctaTitle="Ready to accelerate your international distribution?"
    ctaDescription="Let TrueLog handle the complexity of global fulfilment so your team can focus on growing market share."
  />
);

export default OemsHardware;
